module.exports = __webpack_public_path__ + "img/MS.e2450430.png";